// @ts-nocheck
/**
* ATTENTION!
* @generated THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
*/

import * as Types from '../schema';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client/react';
import * as ApolloReactHooks from '@apollo/client/react';
const defaultOptions = {} as const;
export type CreateChatFileUploadIntentMutationVariables = Types.Exact<{
  input: Types.CreateChatFileUploadIntentInput;
}>;


export type CreateChatFileUploadIntentMutation = { __typename?: 'Mutation', createChatFileUploadIntent: { __typename?: 'ChatFileUploadIntent', uploadUrl: string, expiresAt: any, file: { __typename?: 'ChatFile', id: string, sessionId: string, messageId?: string | null, origin: Types.ChatFileOrigin, status: Types.ChatFileStatus, fileName: string, mimeType?: string | null, size?: number | null, width?: number | null, height?: number | null, failureCode?: string | null, operationId?: string | null, createdAt: any } } };


export const CreateChatFileUploadIntentDocument = gql`
    mutation CreateChatFileUploadIntent($input: CreateChatFileUploadIntentInput!) {
  createChatFileUploadIntent(input: $input) {
    uploadUrl
    expiresAt
    file {
      id
      sessionId
      messageId
      origin
      status
      fileName
      mimeType
      size
      width
      height
      failureCode
      operationId
      createdAt
    }
  }
}
    `;

/**
 * __useCreateChatFileUploadIntentMutation__
 *
 * To run a mutation, you first call `useCreateChatFileUploadIntentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateChatFileUploadIntentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createChatFileUploadIntentMutation, { data, loading, error }] = useCreateChatFileUploadIntentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateChatFileUploadIntentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateChatFileUploadIntentMutation, CreateChatFileUploadIntentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateChatFileUploadIntentMutation, CreateChatFileUploadIntentMutationVariables>(CreateChatFileUploadIntentDocument, options);
      }
export type CreateChatFileUploadIntentMutationHookResult = ReturnType<typeof useCreateChatFileUploadIntentMutation>;
export type CreateChatFileUploadIntentMutationResult = ApolloReactCommon.MutationResult<CreateChatFileUploadIntentMutation>;